import React from 'react'
import EventBaseSelectionInputWrapper, {
  EventBaseSelectionInputWrapperProps,
} from './EventBaseSelectionInputWrapper'
import EventSubSelectionInputContent, {
  EventSubSelectionInputContentProps,
} from './EventSubSelectionInputContent'

export type EventBaseSelectionInputProps = Omit<
  EventBaseSelectionInputWrapperProps,
  'children'
> &
  EventSubSelectionInputContentProps

const EventBaseSelectionInput: React.FC<EventBaseSelectionInputProps> = ({
  label,
  choices = [],
  disableInputs,
  hideQuantity = false,
  ...rest
}) => (
  <EventBaseSelectionInputWrapper disableInputs={disableInputs} {...rest}>
    <EventSubSelectionInputContent
      label={label}
      choices={choices}
      hideQuantity={hideQuantity}
      disableInputs={disableInputs}
    />
  </EventBaseSelectionInputWrapper>
)

export default EventBaseSelectionInput
